import { extract } from '@app/core';
import { GamesWrapperComponent } from '@app/_v2/games/games.component';
import { GameCanvasComponent } from '@app/_v2/games/game-canvas/game-canvas.component';
var ɵ0 = { title: extract('Edgeless - Under the aegis'), allowChat: false }, ɵ1 = { title: extract('Edgeless - Treasure hunt'), allowChat: true, subHeader: true }, ɵ2 = { title: extract('Edgeless - Roulette'), allowChat: true, subHeader: true }, ɵ3 = { title: extract('Edgeless - Video poker'), allowChat: true, subHeader: true }, ɵ4 = { title: extract('Edgeless - Dice'), allowChat: true, subHeader: true }, ɵ5 = { title: extract('Edgeless - Slots'), allowChat: true, subHeader: true }, ɵ6 = { title: extract('Edgeless - BlackJack'), allowChat: true, subHeader: true }, ɵ7 = { title: extract('Edgeless - Crash'), allowChat: true, subHeader: true }, ɵ8 = { title: extract('Edgeless - Crypto gems'), allowChat: true, subHeader: true };
var routes = [
    {
        path: '',
        component: GamesWrapperComponent,
        children: [
            {
                path: '',
                redirectTo: '/home',
                pathMatch: 'full',
            },
            {
                path: 'under-the-aegis',
                loadChildren: 'app/_v2/games/under-the-aegis/under-the-aegis.module#UnderTheAegisModule',
                data: ɵ0,
            },
            {
                path: '',
                component: GameCanvasComponent,
                children: [
                    {
                        path: 'treasure-hunt',
                        loadChildren: 'app/_v2/games/treasure/treasure.module#TreasureModule',
                        data: ɵ1,
                    },
                    {
                        path: 'roulette',
                        loadChildren: 'app/_v2/games/roulette/roulette.module#RouletteModule',
                        data: ɵ2,
                    },
                    {
                        path: 'video-poker',
                        loadChildren: 'app/_v2/games/video-poker/video-poker.module#VideoPokerModule',
                        data: ɵ3,
                    },
                    {
                        path: 'dice',
                        loadChildren: 'app/_v2/games/dice/dice.module#DiceModuleV2',
                        data: ɵ4,
                    },
                    // {
                    //   path: 'spooky-dice',
                    //   loadChildren: 'app/_v2/games/spooky-dice/spooky-dice.module#SpookyDiceModuleV2',
                    //   data: { title: extract('Edgeless - Spooky dice'), allowChat: true, subHeader: true },
                    // },
                    // {
                    //   path: 'ice-dice',
                    //   loadChildren: 'app/_v2/games/ice-dice/ice-dice.module#IceDiceModuleV2',
                    //   data: { title: extract('Edgeless - Ice dice'), allowChat: true, subHeader: true },
                    // },
                    {
                        path: 'slots',
                        loadChildren: 'app/_v2/games/slots/slots.module#SlotsModuleV2',
                        // canLoad: [VipMemberGuard],
                        data: ɵ5,
                    },
                    // {
                    //   path: 'baccarat',
                    //   loadChildren: 'app/_v2/games/baccarat/baccarat.module#BaccaratModule',
                    //   data: { title: extract('Edgeless - Baccarat'), allowChat: true, subHeader: true },
                    // },
                    {
                        path: 'blackjack',
                        loadChildren: 'app/_v2/games/blackjack/blackjack.module#BlackjackModule',
                        data: ɵ6,
                    },
                    {
                        path: 'crash',
                        loadChildren: 'app/_v2/games/crash/crash.module#CrashModuleV2',
                        data: ɵ7,
                    },
                    {
                        path: 'crypto-gems',
                        loadChildren: 'app/_v2/games/crypto-gems/crypto-gems.module#CryptoGemsModule',
                        data: ɵ8,
                    },
                ],
            },
        ],
    },
];
var GamesRoutingModule = /** @class */ (function () {
    function GamesRoutingModule() {
    }
    return GamesRoutingModule;
}());
export { GamesRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8 };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/games-routing.module.ts.pre-build-optimizer.js